import type { AxiosProgressEvent } from 'axios';
import cn from 'classnames';
import type React from 'react';
import { CircularProgress } from '@mui/material';
import { Loader } from '@src/library/components/common';
import * as st from './styles.module.scss';

type Props = {
  progress?: AxiosProgressEvent;
  title?: string;
  customStyles?: React.CSSProperties;
  className?: string;
};

export const UploadProgressCard: React.FC<Props> = ({
  className,
  progress,
  title,
  customStyles,
}) => {
  const percentCompleted =
    progress && progress.total ? Math.round((progress.loaded * 100) / progress.total) : 0;
  const speed = progress && progress.rate ? Math.round(progress.rate / 1000) : 0;
  const timeRemaining = progress && progress.estimated ? Math.round(progress.estimated) : 0;

  return (
    <div className={cn(st.status, className)} style={customStyles}>
      {progress && progress.loaded ? (
        <>
          <p>Остаток времени: {timeRemaining} с</p>
          <p>Скорость загрузки: {speed} kb/s</p>
          <p>{percentCompleted}%</p>
          <progress className={st.progressbar} max={100} value={percentCompleted} />
          <span>{title || 'Данные обновляются'}</span>
        </>
      ) : (
        <>
          <Loader />
        </>
      )}
    </div>
  );
};
